
export default {
  placesCarousel: {
    'layer': 'Capa',
    'lat': 'Lat.',
    'lon': 'Lon.',
    'notAvailable': 'No disponible',
    'placeDetails': 'Detalles del lugar',
    'next': 'Próximo bloque',
    'prev': 'Bloque anterior',
    'directionsTo': 'Direcciones',
    'distance': 'Distancia',
    'distanceFromLocationMarkedOnTheMap': 'Distancia aproximada desde el lugar marcado en el mapa',
    'selectPlace': 'Seleccionar'
  }
}
